/* av-core @c:a89de4971ab8 — GENERATED by tools/av-emit.mjs from venkatron/Chirp av-core/. Do not edit; edit the source and re-emit.
   vectors: tools/vectors/av-core.json sha256:60692c4a12663f7a1b44e4d53fc46e5b868c447db08df9eb30043988818613a7 (av-core (source): mulberry32 8/8 · midiHz 20/20 · pitch 14/14 · scheduler 10/10 · music 39/39)
   modules: rng sha256:ad7b35e0cb42 · pitch sha256:9b047ec52957 · clock sha256:a7215d00b342 · theory sha256:0a9398951c90
   Clock dialect: flock — division = BEATS PER STEP (gesture_synth's division_gs = 1 / division). */

// ── rng (av-core/rng.js) — mulberry32, streamSeed, rngStream ──
/* av-core · rng — seeded randomness. Plain ES2020, no imports, no globals.
   Source of truth for the flock's inline mulberry32 copies (clutch, flameback,
   gyre, myna, nightjar, shrike, soar; MOLT's hwfRng). MOLT's dirRng is a
   reasoned fork (seed 0 → 0x9e3779b9) and stays outside: see
   tools/av-vectors.allow.json. */

// mulberry32 — a 32-bit state PRNG, draws in [0, 1). Any number is a seed;
// it is coerced to int32 on the first draw, so -1 and 4294967295 agree.
export function mulberry32(a){
  return function(){
    a |= 0; a = a + 0x6D2B79F5 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

// The flock's sub-stream idiom, named (GYRE carries it ~20 times):
//   mulberry32(((seed>>>0) ^ Math.imul(index, salt))>>>0)
// so one world seed deals independent, repeatable streams per bar / tile /
// voice. `index` is used as given — callers that want stream 0 to differ
// from the parent seed pass index+1, exactly as the pages do.
export const streamSeed = (seed, index, salt = 0x9E3779B1) =>
  ((seed >>> 0) ^ Math.imul(index, salt)) >>> 0;
export const rngStream = (seed, index, salt = 0x9E3779B1) =>
  mulberry32(streamSeed(seed, index, salt));

// ── pitch (av-core/pitch.js) — clamp, midiHz, degreeSemis, cutoffHz, unisonFan, driveCurve ──
/* av-core · pitch — frequency and curve laws. Pure: no AudioContext, no DOM,
   no state. Plain ES2020, no imports, no globals. Derived from BITTERN's GULAR
   (midiHz, degreeSemis, cutoffHz, unisonFan, driveCurve) as of Chirp #33, which
   is gesture_synth src/audio/common/pitch.ts in behaviour. */

export const clamp = (lo, hi, v) => v < lo ? lo : v > hi ? hi : v;

// Equal temperament with a cents trim. The one frequency formula.
export const midiHz = (midi, cents = 0) => 440 * Math.pow(2, (midi - 69) / 12 + cents / 1200);

// Any integer degree (negatives fine) → semitone offset from the scale root,
// octave-wrapped. `steps` is the step array (or a scale entry with .steps).
// The flock's by-id form is theory.js scaleDegreeSemis(scaleId, deg).
export function degreeSemis(steps, deg){
  const s = Array.isArray(steps) ? steps : steps.steps, n = s.length;
  return 12 * Math.floor(deg / n) + s[((deg % n) + n) % n];
}

// The cutoff law: 0..1 → lo..hi Hz, logarithmic, clamped to the range.
// Defaults are the shared law (180..9000); a bird's own range (BITTERN
// 40..8000) is passed as parameters, not forked.
export const cutoffHz = (v, lo = 180, hi = 9000) => lo * Math.pow(hi / lo, Math.min(1, Math.max(0, v)));

// Unison fan: voice i of U spread across -1..1, symmetric, 0 when alone.
export const unisonFan = (i, U) => U > 1 ? (i - (U - 1) / 2) / ((U - 1) / 2) : 0;

// The screamer's transfer curve — odd, bounded, identity at zero drive.
export function driveCurve(amount, N = 1024){
  const c = new Float32Array(N);
  const k = amount * 24;
  for (let i = 0; i < N; i++){
    const x = i / (N - 1) * 2 - 1;
    c[i] = k > 0 ? Math.tanh(k * x) / Math.tanh(k) : x;
  }
  return c;
}

// ── clock (av-core/clock.js) — LOOKAHEAD, TICK_MS, FIRST_OFFSET, stepSeconds, stepsInWindow, missedSteps, createClock ──
/* av-core · clock — the lookahead scheduler, in the flock dialect.
   Plain ES2020, no imports. The AudioContext is passed in (option `context`
   or setContext); timers default to globalThis.setInterval/clearInterval and
   can be injected. Derived from the eight bird Clocks + index.html's scheduler
   half as of Chirp #32 (catch-up guard), with gesture_synth's transport.ts
   extras (stepSeconds, stepsInWindow, nextGrid, at, stopAll, active) added
   without changing flock behaviour.

   DIALECT (flock): `division` is BEATS PER STEP — 1 = every beat, 0.5 =
   eighths, 4 = every bar of 4/4 — and a step's index is reported as `beat`.
   gesture_synth's `division` is steps per beat: division_gs = 1 / division. */

export const LOOKAHEAD = 0.12;   // s booked ahead of the audio clock
export const TICK_MS = 25;       // ms between wakes; << LOOKAHEAD, jitter-proof
export const FIRST_OFFSET = 0.06; // s — a new task's first step lands this far ahead

// Seconds per step (flock dialect: division = beats per step).
export const stepSeconds = (bpm, division) => (60 / bpm) * division;

// Steps one lookahead window would book, given the clock position and the
// next pending step time. Pure — the scheduler's arithmetic without a context.
export function stepsInWindow(now, nextTime, bpm, division, lookahead = LOOKAHEAD){
  const step = stepSeconds(bpm, division);
  let t = nextTime, n = 0;
  while (t < now + lookahead && n < 1000){ n++; t += step; }
  return n;
}

// The catch-up guard as a pure law: how many steps a late wake must skip.
// 0 unless the pending step is more than one lookahead in the past.
export const missedSteps = (now, nextTime, stepSec, lookahead = LOOKAHEAD) =>
  now - nextTime > lookahead ? Math.ceil((now - nextTime) / stepSec) : 0;

/* createClock(options) → the flock's Clock object.
     context      AudioContext-like ({ currentTime }) or () => one; null until set
     lookahead    s (0.12) · tick ms (25) · firstOffset s (0.06)
     epoch        nextGrid's anchor; default = currentTime when a context is first seen
     onStep       (time, beat, handle) after each booked step — debug surfaces
     onError      (err, handle) when a task cb throws; the task is cancelled
                  unless it returns true (flock default: cancel, silently)
     setInterval / clearInterval   timer injection (tests, worklet-free hosts) */
export function createClock(options = {}){
  const o = options;
  const lookahead = o.lookahead != null ? o.lookahead : LOOKAHEAD;
  const tickMs = o.tick != null ? o.tick : TICK_MS;
  const firstOffset = o.firstOffset != null ? o.firstOffset : FIRST_OFFSET;
  const setI = o.setInterval || ((fn, ms) => globalThis.setInterval(fn, ms));
  const clearI = o.clearInterval || (id => globalThis.clearInterval(id));
  let ctxFn = null, epoch = o.epoch != null ? o.epoch : null;
  let tasks = [], oneShots = [], timer = null;

  function setContext(c){ ctxFn = typeof c === 'function' ? c : () => c; }
  if (o.context != null) setContext(o.context);
  const ctxNow = () => {
    const c = ctxFn ? ctxFn() : null; if (!c) return null;
    if (epoch == null) epoch = c.currentTime;
    return c.currentTime;
  };
  function idle(){ if (timer != null) clearI(timer); timer = null; } // idle = zero cost
  function ensureTimer(){ if (timer == null) timer = setI(tick, tickMs); }

  function tick(){
    const now = ctxNow(); if (now == null) return;
    for (const t of tasks){
      if (t.nextTime == null) t.nextTime = now + firstOffset;
      // Catch-up guard (as gesture_synth transport.ts): a late wake (throttled
      // tab, long stall) would book every missed step in the past and Web Audio
      // fires them as one burst. Skip them; advance the beat by the skipped count.
      if (now - t.nextTime > lookahead){
        const stepSec = (60 / t.bpm) * t.division, missed = Math.ceil((now - t.nextTime) / stepSec);
        t.beat += missed; t.nextTime += missed * stepSec;
      }
      while (!t.cancelled && t.nextTime < now + lookahead){
        try { t.cb(t.nextTime, t.beat); }
        catch (e) { if (!(o.onError && o.onError(e, t.handle) === true)) t.cancelled = true; }
        if (o.onStep) o.onStep(t.nextTime, t.beat, t.handle);
        t.beat++; t.nextTime += (60 / t.bpm) * t.division;
      }
    }
    if (oneShots.length){
      const due = oneShots.filter(s => s.time < now + lookahead);
      oneShots = oneShots.filter(s => s.time >= now + lookahead);
      for (const s of due) s.cb(s.time);
    }
    tasks = tasks.filter(t => !t.cancelled);
    if (!tasks.length && !oneShots.length) idle();
  }

  // Register a repeating musical task: cb(atCtxTime, beatIndex) fires one
  // lookahead early with the exact context timestamp to schedule audio at.
  // Returns a cancel function (flock) that is also a handle (gesture_synth):
  // .cancel() .setBpm(b) .setDivision(d) and live .beat / .step / .bpm / .division.
  function addTask({ bpm = 120, division = 1, cb }){
    const t = { bpm, division, cb, nextTime: null, beat: 0, cancelled: false, handle: null };
    const cancel = () => { t.cancelled = true; };
    t.handle = Object.defineProperties(cancel, {
      cancel:      { value: cancel },
      setBpm:      { value: b => { t.bpm = b; } },
      setDivision: { value: d => { t.division = d; } },
      beat:        { get: () => t.beat },
      step:        { get: () => t.beat },
      bpm:         { get: () => t.bpm },
      division:    { get: () => t.division },
      cancelled:   { get: () => t.cancelled },
    });
    tasks.push(t);
    ensureTimer();
    return t.handle;
  }

  // GYRE's conductor retune: every running task reads t.bpm at each step, so
  // a tempo change is one field write; beat and nextTime accumulate on.
  function setBpm(b){ for (const t of tasks) t.bpm = b; }

  // One-shot (gesture_synth): cb(time) once `time` enters the lookahead window,
  // so it samples state at fire-decision time, one lookahead before sound.
  function at(time, cb){ oneShots.push({ time, cb }); ensureTimer(); }

  // The next grid line strictly ahead of the audio clock (+20 ms margin),
  // anchored at the epoch. Flock dialect: division = beats per step.
  // null while no context is set.
  function nextGrid(bpm, division){
    const now = ctxNow(); if (now == null) return null;
    const step = stepSeconds(bpm, division), notBefore = now + 0.02;
    const k = Math.max(0, Math.ceil((notBefore - epoch) / step));
    const t = epoch + k * step;
    return t > notBefore ? t : t + step;
  }

  function stopAll(){
    for (const t of tasks) t.cancelled = true;
    tasks = []; oneShots = []; idle();
  }

  return {
    addTask, setContext, setBpm, at, nextGrid, stopAll,
    get active(){ return tasks.filter(t => !t.cancelled).length; },
    LOOKAHEAD: lookahead,
  };
}

// ── theory (av-core/theory.js) — SCALES, QUALITIES, scaleDegreeSemis, chordTones, triadQuality, buildSeq, computeRuns, KONNAKOL_MAP, parseKonnakol ──
/* av-core · theory — scales, chords, the arp builder, the run grammar and
   konnakol. Pure tables and functions: plain ES2020, no imports, no globals.
   Derived from TRILL's SYRINX tables (the superset: GYRE's and SOAR's are
   subsets with identical steps), TRILL's buildSeq, BITTERN's computeRuns and
   FLAMEBACK's parseKonnakol, as of Chirp #34. A page keeps whatever subset
   (and labels) its UI shows; every function takes an optional table. */

export const SCALES = {
  major:      { label:'MAJOR',    steps:[0,2,4,5,7,9,11] },
  minor:      { label:'MINOR',    steps:[0,2,3,5,7,8,10] },
  dorian:     { label:'DORIAN',   steps:[0,2,3,5,7,9,10] },
  phrygian:   { label:'PHRYGIAN', steps:[0,1,3,5,7,8,10] },
  lydian:     { label:'LYDIAN',   steps:[0,2,4,6,7,9,11] },
  mixolydian: { label:'MIXO',     steps:[0,2,4,5,7,9,10] },
  harmminor:  { label:'HARM MIN', steps:[0,2,3,5,7,8,11] },
  melminor:   { label:'MEL MIN',  steps:[0,2,3,5,7,9,11] }, // the ascent; it never descends here
  wholetone:  { label:'WHOLE',    steps:[0,2,4,6,8,10] },
  blues:      { label:'BLUES',    steps:[0,3,5,6,7,10] },   // minor blues — the ♭5 is the point
  minpent:    { label:'MIN PENT', steps:[0,3,5,7,10] },
  majpent:    { label:'MAJ PENT', steps:[0,2,4,7,9] },
  // Ragas, 12-TET approximations — the swara sets, honestly tabled. Where a
  // set shares a mode's ladder (Yaman/lydian, Kafi/dorian) the raga is the
  // grammar, not the rungs; the table only keeps rungs.
  lalit:      { label:'LALIT',    steps:[0,1,4,5,6,8,11] }, // S r G M M' d N — both madhyams, no Pa
  bairagi:    { label:'BAIRAGI',  steps:[0,1,5,7,10] },     // S r M P n — morning austerity
  bhairavi:   { label:'BHAIRAVI', steps:[0,1,3,5,7,8,10] }, // S r g M P d n — komal everything
  yaman:      { label:'YAMAN',    steps:[0,2,4,6,7,9,11] }, // S R G M' P D N — tivra Ma at dusk
  bhairav:    { label:'BHAIRAV',  steps:[0,1,4,5,7,8,11] }, // S r G M P d N — dawn, both komal edges
  kafi:       { label:'KAFI',     steps:[0,2,3,5,7,9,10] }, // S R g M P D n — the thumri home
  malkauns:   { label:'MALKAUNS', steps:[0,3,5,8,10] },     // S g M d n — midnight gravity
  hamsa:      { label:'HAMSA',    steps:[0,2,4,7,11] },     // Hamsadhwani: S R G P N — the opener
  charukesi:  { label:'CHARUKESI',steps:[0,2,4,5,7,8,10] }, // S R G M P d n — major till the six bends
};
export const QUALITIES = { triad:3, seventh:4, ninth:5 };

// The flock's by-id degree rail (BITTERN/MYNA/CLUTCH/GYRE degreeSemis):
// any integer degree lands on an in-scale semitone, octave-wrapped.
export function scaleDegreeSemis(scaleId, deg, table = SCALES){
  const steps = table[scaleId].steps, n = steps.length;
  return 12 * Math.floor(deg / n) + steps[((deg % n) + n) % n];
}

// Stacked diatonic thirds on a scale degree — semitone offsets from the
// scale root, octave-wrapped. Every tone is in-scale by construction.
export function chordTones(scaleId, degree, quality, table = SCALES){
  const steps = table[scaleId].steps, n = steps.length;
  const size = QUALITIES[quality] || 3, out = [];
  for (let i = 0; i < size; i++){
    const d = degree + 2 * i;
    out.push(12 * Math.floor(d / n) + steps[((d % n) + n) % n]);   // negative degrees wrap an octave down
  }
  return out;
}
export function triadQuality(scaleId, degree, table = SCALES){
  const t = chordTones(scaleId, degree, 'triad', table);
  const third = t[1] - t[0], fifth = t[2] - t[0];
  if (third === 4 && fifth === 7) return 'maj';   // exact matches only — raga
  if (third === 3 && fifth === 7) return 'min';   // stacks earn 'open', not a
  if (third === 3 && fifth === 6) return 'dim';   // mislabeled western name
  if (third === 4 && fifth === 8) return 'aug';
  return 'open'; // quartal / ♭5 / raga color — still in-scale, by construction
}

// Pure sequence builder — the testable heart of TRILL's arp. 'up' repeats the
// chord figure per octave; 'updown' drops the doubled endpoints; 'random'
// returns the note set and lets the step picker choose.
export function buildSeq(scaleId, degree, quality, octaves, pattern, base, table = SCALES){
  const tones = chordTones(scaleId, degree, quality, table);
  const up = [];
  for (let o = 0; o < octaves; o++) tones.forEach(t => up.push(base + t + 12 * o));
  if (pattern === 'down') return up.slice().reverse();
  if (pattern === 'updown' && up.length > 2) return up.concat(up.slice(1, -1).reverse());
  return up;
}

// The run grammar (BITTERN). slide[i] ties step i into step i+1 (the 303
// way): a run is an on-step nothing ties into, plus every tied follower. A
// full bar of ties is one drone. `len` (gesture_synth) defaults to the
// flock's 16.
export function computeRuns(mask, slide, len = 16){
  const runs = [], starts = [];
  for (let s = 0; s < len; s++){
    if (!mask[s]) continue;
    const p = (s + len - 1) % len;
    if (mask[p] && slide[p]) continue; // tied into — not a start
    starts.push(s);
  }
  if (!starts.length && mask.every(v => v)) starts.push(0); // the infinite tie
  for (const s of starts){
    const steps = [s];
    let cur = s;
    while (steps.length < len){
      const nxt = (cur + 1) % len;
      if (slide[cur] && mask[nxt] && nxt !== s){ steps.push(nxt); cur = nxt; }
      else break;
    }
    runs.push({ start: s, steps });
  }
  return runs;
}

// KONNAKOL (FLAMEBACK) — solkattu syllable → mridangam stroke row. One
// school's hands: a drill, not a decree.
export const KONNAKOL_MAP = {
  // treble / right hand
  ta:'tha', tha:'tha', thaa:'tha', thi:'tha',
  ka:'ka', ki:'ka', ku:'ka',
  dhi:'dhin', di:'dhin', dhin:'dhin', din:'dhin', dhim:'dhin',
  mi:'nam', na:'nam', nam:'nam', nan:'nam', nom:'nam',
  cha:'chapu', chapu:'chapu', chi:'chapu',
  // bass / left hand
  thom:'thom', dhom:'thom', dom:'thom', gu:'thom', num:'thom', ghum:'thom',
  gum:'gumup', jham:'gumup', jam:'gumup',
  // composites (both heads)
  dheem:'dheem', dhee:'dheem',
  tham:'tham',
  dhimi:'dhimi',
};
// text → { steps:[rowId|null], unknown:[raw] }. A null step is a rest;
// a comma / dash / dot is the spoken karvai.
export function parseKonnakol(text, map = KONNAKOL_MAP){
  const toks = String(text).toLowerCase().replace(/[|/]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  const steps = [], unknown = [];
  for (const t of toks){
    const clean = t.replace(/[^a-z]/g, '');
    if (!clean){ steps.push(null); continue; }        // pure punctuation → a rest / karvai
    const stroke = map[clean];
    if (stroke) steps.push(stroke);
    else { steps.push(null); unknown.push(t); }        // unknown → a rest, but flagged honestly
  }
  return { steps, unknown };
}
